import { createSelector } from 'reselect';

const forgotPassword = state => state.modules.forgotPassword;

export const getForgotPasswordStatus = createSelector(
  forgotPassword,
  state => state.forgotPasswordStatus
);